<template>
    <section class="app-main">
        <div class="top-bar">
            <el-input placeholder="输入商品名称" v-model="title" @change="search()" class="search-input m-right-2">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-input placeholder="输入条形码" v-model="barcode1" @change="searchbarcode()" class="search-input m-right-2">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button type="success" plain @click="handleAdd(ids)">添加图片</el-button>

        </div>
 
        <el-card shadow="hover">
            <el-table :data="tableData"  @selection-change="handleChecked" max-height="600"  ref="table"  style="width: 100%">
                <el-table-column type="selection"   width="80"          align="center"> </el-table-column>
                <el-table-column    label="商品图片"  align="center"  width="120">
                    <template slot-scope="scope">
                         <table-img :src="scope.row.purchase_pic_url"></table-img>
                    </template>
                </el-table-column>
                <el-table-column  prop="purchase_title" label="商品名称" align="center" width="180" show-overflow-tooltip></el-table-column>
                <el-table-column  prop="batch"  align="center" label="批次" width="160"></el-table-column>

                <el-table-column property="attr_symbol_string" label="规格属性"  align="center" width="220" show-overflow-tooltip>
                    <template slot-scope="scope">
                           <div v-for="item in scope.row.specs" :key="item.attr_symbol_string" style="height:35px;line-height:35px;width:100%;">
                                    <span>{{item.attr_symbol_string}}</span>
                            </div>
                    </template>
                </el-table-column>
                    <el-table-column property="barcode" label="SKU"  align="center" min-width="120px"  show-overflow-tooltip>
                         <template slot-scope="scope">
                            <div v-for="ik in scope.row.specs" :key="ik.barcode" style="height:35px;line-height:35px;width:100%;">
                                    <span>{{ik.barcode}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column property="pric"   label="进货价"  align="center" min-width="120px">
                        <template slot-scope="scope">
                            <div v-for="(it,p) in scope.row.specs" :key="p" style="height:35px;line-height:35px;">
                                    C$<el-input  v-model="it.price" @change="handleSet(it.id,it.price,1)" size="mini"  style="width:80px"></el-input>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column property="address" label="进货数量" align="center" min-width="120px">
                            <template slot-scope="scope">
                            <div v-for="(ite,o) in scope.row.specs" :key="o" style="height:35px;line-height:35px;">
                                    <el-input  v-model="ite.number" @change="handleSet(ite.id,ite.number,2)" size="mini"  style="width:80px"></el-input>
                            </div>
                        </template>
                    </el-table-column>

                <el-table-column prop="total_price"  align="center" label="单款合计金额">
                    <template slot-scope="scope">C${{scope.row.total_price}}</template>
                </el-table-column>
                <el-table-column align="center" label="交易记录">
                    <template slot-scope="scope" >
                        <div v-if="typeof(scope.row.transaction_record) == 'object'">
                            <div  v-for="(it,index) in scope.row.transaction_record" :key="index" class="shopImg">
                                <el-image  :src="it.url"  style="width:100%;height:70%;"></el-image>
                            </div>
                            <el-button  size="small" type="text" @click="delImg(scope.row,2)"  style="width:80px;">添加(删除)图片</el-button >
                        </div>
                        
                        <el-button v-else  size="small" type="text" @click="showDialog(2,scope.row)"  style="width:80px;">查看图片</el-button >
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background layout="prev, pager, next, jumper"  style="padding:10px" :page-size="size" :total="total"  @current-change="loadMore"></el-pagination>
        </el-card>

        
        <el-dialog title="查看图片" :visible.sync="invoice_modal" style="min-height: 100px;" @close="close">
            <el-card class="m-bottom-3 uploadVc" style="dispaly:flex;">
                <div v-if="row.transaction_pic" style="margin-left:20px;display:flex;overflow-x: auto;">
                    <div v-for="(item,i) in row.transaction_pic_url_arr" :key="i">
                        <tableImgs :src="item.url" alt="" width="300" height="300" style="width:150px;height:150px;" @handleRemove="handleRemove(item.pic_id, i)"></tableImgs>
                    </div>
                </div>
                <div v-else style="text-align:center">
                    暂无图片
                </div>
            </el-card>
        </el-dialog>
        <el-dialog title="上传交易凭证" :visible.sync="invoice_modal2" >
            <el-card class="m-bottom-3 uploadVc" style="dispaly:flex;">
                <imgs-upload ref="childrenDom"  @success="handleSuccess" @resetClear="handleClear" :clear="clear" file-name="ordertransaction" url="ordertransaction/uploads" del-url="ordertransaction/delpic" ></imgs-upload>
            </el-card>
            <el-card>
                <el-row  :gutter="20">
                    <el-col :span="21">
                        <el-button  @click="handleSubmit(ids,imgs_ids)" type="success" plain style="width:150px">确认上传</el-button>
                    </el-col>
                </el-row>
            </el-card>
        </el-dialog>

        <!-- 规格变量详情 -->
        <el-dialog :title="sku_title" :visible.sync="sku_modal" width="1000px">
            <el-card shadow="hover">
                <el-table :data="skuData" max-height="400px">
                    <el-table-column property="attr_symbol_string" label="规格属性"  align="center"></el-table-column>
                    <el-table-column property="barcode" label="SKU"  align="center"></el-table-column>
                    <el-table-column property="price"   label="进货价"  align="center">
                        <template slot-scope="scope">
                            C$<el-input  v-model="scope.row.price" size="mini"  style="width:80px"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column property="address" label="进货数量" align="center">
                        <template slot-scope="scope">
                            <el-input  v-model="scope.row.number" size="mini"  style="width:80px"></el-input>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
        </el-dialog>

        <!-- <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="img">
        </el-dialog> -->

    </section>
</template>



<script>
import { purchase_list, ordertransaction, img_del, update_orderbuy, purchase_addtransaction } from '@/api/buy.js'
import tableImg from '@/components/Image.vue'
import tableImgs from '@/components/Images.vue'
import ImgsUpload from '@/components/uploads.vue'
export default {
    components:{ tableImg, tableImgs, ImgsUpload },
    data() {
        return {
            page:1,
            total:0,
            size: 20,
            title: '',
            barcode1: '',
            tableData:[],
            ids:'',
            m_page:1,
            m_total:0,
            imgsData:[],
            imgs_ids:'',
            rowId:'',
            sku_modal:false,         // 查看规格变量 弹窗控制
            sku_title:'',       
            skuData:[],      
            invoice_modal:false,     // 查看交易凭证 弹窗控制
            invoice_modal2:false,// 上传交易凭证 弹窗控制
            clear:0,                 // 清空 imgsUpload 内容  0 不清空；1 提交成功之后清空； 2 未提交页面发生改变 需要删除当前上传的参数； 
            row:{},
            order_id: ''
        }
    },
    methods: {
        getData(){
            let params = {
                page:this.page,
                belongs: 1
            }
            if(this.title != "" || this.barcode1 != ""){
                params.title_search = this.title,
                params.barcode = this.barcode1
            }
            purchase_list(2,params).then(res => {
                if(res){
                    this.tableData = res.data.data
                    this.total     = res.data.total
                    this.size      = res.data.per_page
                }else{
                    this.tableData = []
                }

            })
        },
        search() {
            this.page = 1;
            this.getData();
        },
        searchbarcode() {
            this.page = 1;
            this.getData();
        },
        loadMore(page){
            this.page = page;
            this.getData()
        },
        // 修改
        handleSet(id,setVal,num){
            let params = {}
            if (num == 1) {
                params.price = setVal
            } else if(num == 2) {
                params.number = setVal
            } else {
                return false
            }
            
            update_orderbuy(id,params).then(res => {
                if(res){
                    this.getData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                }
            })
        },
        handleAdd() {
            if (this.ids) {
                this.invoice_modal2 = true
            }else{
                this.$message.error('请先选择商品！')
            }
        },
        handleSubmit(ids,imgs_ids) {
           if (ids && imgs_ids) {
               let params = {
                   transaction_pic: imgs_ids += this.rowId,
                   ids:ids
               }
               purchase_addtransaction(params).then(res => {  
                   if(res){
                      this.handleClear();
                      this.invoice_modal2 = false
                      this.getData(); 
                      this.$message({type:'success',message:res.msg,duration:1500})
                   }
               })
                
            }
        },
         loadMore2(page){
            this.m_page = page;
            this.getImgs()
        },
        // 获取交易图片列表
        getImgs(){
            let params = {
                page:this.m_page,
            }
            ordertransaction(params).then(res => {
                if(res){
                    this.imgsData = res.data.data
                    this.m_total  = res.data.total
                    this.m_size   = res.data.per_page
                }else{
                    this.imgsData = []
                }

            })
        },
        // 搜索数据
        handleSearch(){
            this.page = 1;
            this.getData();
        },
        // 监听table选中  更新 ids 选中id集合
         handleChecked(rows){
            this.ids = ''
            this.rowId = ''
            rows.forEach(e => {
                this.ids += e.id + ','
                this.rowId += e.transaction_pic
            })
        },
        // 点击查看规格变量
        handleSku(row){
            console.log(row)
            this.skuData   = []
            this.sku_title = row.purchase_title 
            this.skuData   = row.specs
            this.sku_modal = true
        },
        // 点击上传交易凭证
        showDialog(type,row){
            // this.getImgs()
            this.row = row;
            this.order_id = row.id
            this.invoice_modal = true;
        },
        handleSuccess(res) {
            this.imgs_ids = ''
            res.data.forEach(e => {
                this.imgs_ids += e.pic_id + ','
            })
        },
        // 图片删除
        handleRemove (id, i){
            let obj = this.tableData.find(item => {
                return item.id == this.order_id
            })
            let picArr = obj.transaction_pic_url_arr
            let params = {
                order_id: this.order_id,
                pic_id: id
            }
            this.$confirm('此操作将删除该图片，是否继续？','提示',{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                img_del(params).then(res => {
                    if(res) {
                        this.$message({message: res.msg, type: 'success'})
                        picArr.splice(i,1)
                    }
                })
            }).catch(()=>{})
            
        },
        close() {
            this.getData()
        },
        // 重置图片上传组件的 clear
        handleClear(){
            this.$refs.childrenDom.imgs = []
            this.clear = 1
        },

        
    },
    created(){
        this.getData()
        // this.getImgs()
    },

    activated() {
        this.getData()
    }
}
</script>

<style lang="less" scoped>
section {
    .input-left {
        height: 40px;
        line-height: 40px;
        min-width:80px ;
    }
    .uploadVc {
        /deep/ .el-card__body {
            display: flex;
        }
    }
}
</style>
